module.exports = __webpack_public_path__ + "img/daires.8333a164.jpg";